import { createStateHook, type HookStateFunction } from 'react-sweet-state';

import { type Actions, store } from '../../main';
import type { IssueAdjustmentsState, LastProcessedChange } from '../../types';

export type UseLastProcessedChangeResult = {
	lastProcessedChange: LastProcessedChange | null;
};

export const useLastProcessedChange: HookStateFunction<UseLastProcessedChangeResult, undefined> =
	createStateHook<IssueAdjustmentsState, Actions, UseLastProcessedChangeResult, undefined>(store, {
		// We need to wrap the selected slice of state to overcome react-sweet-state useHook with selector issue.
		// We rely on the strict equality of lastUserTriggeredChange (the structure of this object
		// will not change on consecutive updates to a given field but the reference will)
		// https://github.com/atlassian/react-sweet-state/issues/167
		selector: (state) => ({ lastProcessedChange: state.lastProcessedChange }),
	});
